import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BookedUsersActionCreators } from '../../../Store/ActionCreators/BookedUsersActionCreators';

// component
import UserBooked from './UserBooked';

// styled component
import { UsersList, UsersListItem } from './style';

class BookedUsers extends Component {
    static propTypes = {
        workoutId: PropTypes.number,
        // from connect
        usersBooked: PropTypes.arrayOf(PropTypes.object),
        loading: PropTypes.bool,
        errFetch: PropTypes.bool,
    };

    componentDidMount() {
        const { workoutId, getUserBooked } = this.props;
        if (workoutId) getUserBooked(workoutId);
    }

    renderUsersList = users => (
        <UsersList>
            {users.map(user => (
                <UsersListItem key={user.id}>
                    <UserBooked {...user} />
                </UsersListItem>
            ))}
        </UsersList>
    );

    filtredUsers = (usersBooked, workingUsers) => {
        const filtredList = usersBooked.filter(bookedItem => {
            return workingUsers.every(workoingUser => {
                return bookedItem.id !== workoingUser.id;
            });
        });

        if (filtredList.length === 0) return false;
        return filtredList;
    };

    render() {
        const { workoutId, usersBooked, workingUsers } = this.props;
        if (!workoutId || usersBooked.length === 0) return null;
        if (workingUsers.length === 0) return this.renderUsersList(usersBooked);

        const filtredUsers = this.filtredUsers(usersBooked, [...workingUsers]);
        return filtredUsers ? this.renderUsersList(filtredUsers) : null;
    }
}

export default connect(
    state => ({
        workoutId: state.workout.id,
        usersBooked: [...state.usersBooked.entities],
        loading: state.usersBooked.loading,
        errFetch: state.usersBooked.err,
    }),
    {
        getUserBooked: BookedUsersActionCreators.getUsers,
    },
)(BookedUsers);



// WEBPACK FOOTER //
// ./src/UI/Containers/BookedUsers/index.js